export default __webpack_public_path__ + "1.18.20/static/media/libreLinkUp.07cb949d.svg";